// Wrapper to centralize custom fetch logic
// This assumes the expected response is always json


export async function fetchWrapper(url, options={}) {
  const res = await fetch(url, options);

  // This allows us to read the body and still return the original response
  const clone = res.clone();

  let data;
  try {
    data = await clone.json();
    //
  } catch (e) {
    // TODO: Return a new response with valid json
    return res;
  }

  // Custom logic we want to do with the data
  if (!clone.ok) {
    const msg = data.message || data.error || 'Something went wrong';
    alert(msg); // TODO: Replace with a proper notification system
  }

  return res;
}
